import Vue from "vue";
import { AclInstaller, AclCreate, AclRule } from "vue-acl";
import router from "@/router";

Vue.use(AclInstaller);

// let initialRole = "admin"

// let userInfo = JSON.parse(localStorage.getItem("userInfo"))
// if(userInfo && userInfo.userRole) initialRole = userInfo.userRole

// let vm = this;
let initialRole = "user";
if (localStorage.getItem("KK_AUTH_TOKEN")) {
  const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

  initialRole = token.userRole;
} else {
  initialRole = "user";
}

// console.log(initialRole)

export default new AclCreate({
  initial: initialRole,
  notfound: "/pages/not-authorized",
  router,
  acceptLocalRules: true,
  globalRules: {
    masteradmin: new AclRule("masteradmin").generate(),
    mastereditor: new AclRule("mastereditor").or("masteradmin").generate(),
    masteruser: new AclRule("masteruser")
      .or("masteradmin")
      .or("mastereditor")
      .generate(),
    admindto: new AclRule('admindto')
    .or("masteradmin")
    .or("mastereditor")
    .or("masteruser")
    .or('admin')
    .generate(),
    admin: new AclRule("admin").or('admindto')
      .or("masteradmin")
      .or("mastereditor")
      .or("masteruser")
      .generate(),
    editor: new AclRule("editor")
      .or("masteradmin").or('admindto')
      .or("mastereditor")
      .or("masteruser")
      .or("admin")
      .generate(),
    user: new AclRule("user")
      .or("masteradmin").or('admindto')
      .or("mastereditor")
      .or("masteruser")
      .or("admin")
      .or("editor")
      .generate(),
    customs: new AclRule("customs")
      .or("masteradmin").or('admindto')
      .or("mastereditor")
      .or("masteruser")
      .or("admin")
      .or("editor")
      .or("user")
      .generate(),
    public: new AclRule("public")
      .or("masteradmin").or('admindto')
      .or("mastereditor")
      .or("masteruser")
      .or("admin")
      .or("editor")
      .or("user")
      .or("customs")
      .generate(),
      apiuser: new AclRule("apiuser")
      .or("public").or('admindto')
      .or("masteradmin")
      .or("mastereditor")
      .or("masteruser")
      .or("admin")
      .or("editor")
      .or("user")
      .or("customs")
      .or("public")
      .generate()
  }
});
